// Loading state is shared with the Google selection coordinator. Requests are
// versioned per field so a late result cannot replace a newer parent's options.
function locationOptionsLoading(select, loading) {
  select.attr('data-geography-loading', String(loading));
  select.removeAttr('data-geography-load-failed');
}

function locationOptionsReset(select, label, failed) {
  select.empty().append(new Option(label, ''));
  locationOptionsLoading(select, false);
  select.attr('data-geography-load-failed', String(!!failed));
  select.trigger('change.select2');
}

function locationOption(row, metadata) {
  var option = $('<option>', {text: row[0], value: row[1]});
  var hints = metadata && metadata[row[0]];
  if (hints) option.attr({
    'data-geography-code': hints.code,
    'data-geography-aliases': JSON.stringify(hints.aliases || []),
    'data-geography-canonical': String(hints.canonical === true)
  });
  return option;
}

// The catalogue determines the applicable administrative level. Keep a blank
// enabled select when hidden so changing a parent clears any previous city ID.
function applyLocationCitySettings(select, response) {
  if (!select || !select.length || typeof response.city_applicable !== 'boolean') return;
  if (typeof select.data('geography-city-required') !== 'boolean') {
    select.data('geography-city-required', !!select.prop('required'));
  }
  var applicable = response.city_applicable;
  select.data('geography-city-applicable', applicable);
  select.attr('data-geography-applicable', String(applicable));
  select.attr('data-geography-field-label', response.city_label || 'City');
  if (!applicable) {
    select.prop('required', false);
  } else if (typeof select.data('geography-city-required') === 'boolean') {
    select.prop('required', select.data('geography-city-required') && !select[0].dataset.skipDynamicRequired);
  }
  var field = select.closest('[data-geography-city-field]');
  field.find('[data-geography-city-label]').text(response.city_label);
  field.find('[data-geography-city-select]').toggleClass('d-none', !applicable);
  field.find('[data-geography-city-note]').text(response.city_note || 'Select your ' + response.city_label.toLowerCase());
}

function locationSelection() {
  $("#select-country, .select-country-input-change-handler").off("change.locationSelection").on("change.locationSelection", function () {
    var elm = this;
    var set_state_url = $(this).data('url');
    var country_id = this.value;
    var dataType = $(this).data('data-type') || 'script';
    var parent = $(elm).parents('.select-input-change-handler');
    // try to find the related state/city selects by id pattern first (select-country-XXX -> select-state-XXX)
    var selId = $(elm).attr('id') || ''
    var elmSelectState = $()
    var elmSelectCity = $()
    if (selId && selId.indexOf('select-country-') === 0) {
      var suffix = selId.replace(/^select-country-/, '')
      elmSelectState = $("#select-state-" + suffix)
      elmSelectCity = $("#select-city-" + suffix)
    }
    // fallback to parent-scoped selectors if id-based lookup failed
    if (!elmSelectState || elmSelectState.length === 0) {
      elmSelectState = parent.find('.select-state-input-change-handler')
    }
    if (!elmSelectCity || elmSelectCity.length === 0) {
      elmSelectCity = parent.find('.select-city-input-change-handler')
    }

    var requestId = elm._geographyStateRequest = (elm._geographyStateRequest || 0) + 1;
    if (elmSelectState[0]) elmSelectState[0]._geographyCityRequest = (elmSelectState[0]._geographyCityRequest || 0) + 1;
    elmSelectState.empty().append(new Option('Loading...', ''));
    elmSelectCity.empty().append(new Option('Loading...', ''));
    if (dataType === 'json') {
      locationOptionsLoading(elmSelectState, true);
      locationOptionsLoading(elmSelectCity, true);
      if (!country_id) {
        locationOptionsReset(elmSelectState, 'Select state');
        locationOptionsReset(elmSelectCity, 'Select city');
        return;
      }
    }

    $.ajax({
      dataType: dataType,
      timeout: 10000,
      url: set_state_url,
      data: {
        country_id: country_id
      },
      success: function (response) {
        if (elm._geographyStateRequest !== requestId || elm.value !== country_id) return;
        if (dataType == "json") {
          elmSelectState.attr('data-geography-applicable', String(response.state_applicable !== false));
          var label_state = response.label_state;
          var label_city = response.label_city;
          var label_area = response.label_area;
          var state_required = typeof response.state_required === 'boolean'
            ? response.state_required
            : response.field_required;
          state_required = state_required && response.state_applicable !== false;
          var city_required = typeof response.city_required === 'boolean'
            ? response.city_required
            : response.field_required;
          elmSelectCity.data('geography-city-required', !!city_required);
          applyLocationCitySettings(elmSelectCity, response);
          var label_sub_area = response.label_sub_area;
          var states = response.states;
          elmSelectState.empty()
          elmSelectCity.empty()
          // $('#select-area').empty()
          // $('#select-sub-area').empty()
          elmSelectState.append($('<option>', {
            value: "",
            text: label_state
          }));
          elmSelectCity.append($('<option>', {
            value: "",
            text: label_city
          }));
          // $('#select-area').append($('<option>', {
          //   value: "",
          //   text: label_area
          // }));

          setTimeout(() => {
            if (elm._geographyStateRequest !== requestId || elm.value !== country_id) return;
            // ensure we have elements before setting properties; fall back to first matching on page
            var targetStateEl = (elmSelectState && elmSelectState.length > 0) ? elmSelectState[0] : (document.querySelector('.select-state-input-change-handler') || null)
            var targetCityEl = (elmSelectCity && elmSelectCity.length > 0) ? elmSelectCity[0] : (document.querySelector('.select-city-input-change-handler') || null)

            parent.find('#span_state_id').toggleClass('required', state_required);

            if (targetStateEl) {
              targetStateEl.required = state_required;
            }

            parent.find('#span_city_id').toggleClass('required', city_required);

            if (targetCityEl) {
              if (city_required && elmSelectCity.data('geography-city-applicable') !== false) {
                if (!targetCityEl.dataset.skipDynamicRequired) {
                  targetCityEl.required = true;
                }
              } else {
                targetCityEl.required = false;
              }
            }
          }, 500);

          // $('#select-sub-area').append($('<option>', {
          //   value: "",
          //   text: label_sub_area
          // }));

          states.forEach(function (state, idx) {
            // body...
            elmSelectState.append(locationOption(state, response.state_metadata));
          })
        }
        elmSelectState.select2();
        elmSelectCity.select2();
        if (dataType === 'json') {
          locationOptionsLoading(elmSelectState, false);
          locationOptionsLoading(elmSelectCity, false);
        }
      },
      error: function (error) {
        if (elm._geographyStateRequest !== requestId || elm.value !== country_id) return;
        if (dataType === 'json') {
          locationOptionsReset(elmSelectState, 'Select state', true);
          locationOptionsReset(elmSelectCity, 'Select city', true);
        }
      }
    })
  });

  $("#select-state, .select-state-input-change-handler").off("change.locationSelection").on("change.locationSelection", function () {
    var elm = this;
    var set_city_url = $(this).data('url');
    var state_id = this.value;
    var dataType = $(this).data('data-type') || 'script';
    var parent = $(elm).parents('.select-input-change-handler');
    // try id-based lookup (select-state-XXX -> select-city-XXX)
    var selId = $(elm).attr('id') || ''
    var elmSelectCity = $()
    if (selId && selId.indexOf('select-state-') === 0) {
      var suffix = selId.replace(/^select-state-/, '')
      elmSelectCity = $("#select-city-" + suffix)
    }
    if (!elmSelectCity || elmSelectCity.length === 0) {
      elmSelectCity = parent.find('.select-city-input-change-handler')
    }

    var requestId = elm._geographyCityRequest = (elm._geographyCityRequest || 0) + 1;
    elmSelectCity.empty().append(new Option('Loading...', ''));
    if (dataType === 'json') {
      locationOptionsLoading(elmSelectCity, true);
      if (!state_id) {
        locationOptionsReset(elmSelectCity, 'Select city');
        return;
      }
    }

    $.ajax({
      dataType: dataType,
      timeout: 10000,
      url: set_city_url,
      data: {
        state_id: state_id
      },
      success: function (response) {
        if (elm._geographyCityRequest !== requestId || elm.value !== state_id) return;
        if (dataType == "json") {
          var label_city = response.label_city;
          var cities = response.cities;
          applyLocationCitySettings(elmSelectCity, response);
          elmSelectCity.empty()
          // $('#select-area').empty()
          elmSelectCity.append($('<option>', {
            value: "",
            text: label_city
          }));
          // $('#select-area').append($('<option>', {
          //   value: "",
          //   text: label_area
          // }));
          // $('#select-sub-area').append($('<option>', {
          //   value: "",
          //   text: label_sub_area
          // }));

          cities.forEach(function (city, idx) {
            // body...
            elmSelectCity.append(locationOption(city, response.city_metadata));
          })
        }
        elmSelectCity.select2();
        if (dataType === 'json') locationOptionsLoading(elmSelectCity, false);
      },
      error: function (error) {
        if (elm._geographyCityRequest !== requestId || elm.value !== state_id) return;
        if (dataType === 'json') locationOptionsReset(elmSelectCity, 'Select city', true);
      }
    })
  });

  $("#select-city").change(function () {
    $('#select-area').empty()
    $('#select-area').append($('<option>', {
      text: "Loading..."
    }));
    var set_area_url = $(this).data('url');
    var city_id = this.value;
    var area_id = this.dataset.areaId;
    if (set_area_url == undefined || set_area_url == "") return true

    $.ajax({
      dataType: 'script',
      url: set_area_url,
      data: {
        area_id: area_id,
        city_id: city_id
      },
    })
  });

  $("#select-area").change(function () {
    $('#select-sub-area').empty()
    $('#select-sub-area').append($('<option>', {
      text: "Loading..."
    }));
    var set_sub_area_url = $(this).data('url');
    var area_id = this.value;
    if (set_sub_area_url == undefined || set_sub_area_url == "") return true

    $.ajax({
      dataType: 'script',
      url: set_sub_area_url,
      data: {
        area_id: area_id
      },
    })
  });
}

document.addEventListener('turbo:load', function () {
  locationSelection();
})

window.locationSelection = locationSelection;
